module.exports = __webpack_public_path__ + "img/solar-system.8ba3b5b1.svg";